import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PlanningProjectsService} from "../../services/planning-projects-service.service";

export class PlanningReportsViewComponent implements IController {

  public filtersConfig: any;
  public reports: any[];
  public reportsCopy: any[] = [];
  public projectGroupStatuses = ['NOT_CREATED', 'STAND_BY', 'STUCK', 'IN_PROGRESS', 'DONE'];
  public reportStatusCount: any;
  public chartSegments: { value: number, color: string, name: string }[];

  constructor(private planningProjectsService: PlanningProjectsService, private $timeout, private moment) {
  }

  $onInit() {
    this.filtersConfig = {
      queryString: undefined,
      branchIds: [],
      groupStatuses: [],
      date: this.moment().valueOf()
    }
    this.getReports();
  }

  onQueryChanged(query) {
    this.filtersConfig.queryString = query;
    this.filterReports();
    this.initPieChartData();
  }

  onStatusChange(statuses) {
    this.filtersConfig.groupStatuses = statuses;
    this.filterReports();
    this.initPieChartData();
  }

  onBranchesChange(branchIds) {
    this.filtersConfig.branchIds = branchIds;
    this.getReports();
  }

  onDatesBrowse(isNext) {
    const date = isNext ?
      this.moment(this.filtersConfig.date).add(1, 'day').valueOf() :
      this.moment(this.filtersConfig.date).subtract(1, 'day').valueOf()

    this.onDateChange(date);
  }

  onDateChange(date) {
    this.filtersConfig.date = date;
    this.getReports();
  }

  onChartSegmentClick(event) {
    this.filtersConfig.groupStatuses = [event.data.name];
    this.filterReports();
    this.initPieChartData();
    this.$timeout(() => {
    }, 0);
  }

  private getReports() {
    this.planningProjectsService.getMonitoring(this.moment(this.filtersConfig.date).startOf('day').valueOf(),
      this.moment(this.filtersConfig.date).endOf('day').valueOf(), this.filtersConfig.branchIds)
      .then((res: any) => {
        this.reports = res.projectStatusMonitorings;
        this.filterReports();
        this.initPieChartData();
      })

  }

  private filterReports() {
    this.reportsCopy = this.reports?.filter(report => {
      return ((!this.filtersConfig.groupStatuses?.length || _.includes(this.filtersConfig.groupStatuses, report.statusGroup)) &&
        (!this.filtersConfig.queryString ||
          (!!report.projectName && report.projectName?.toLowerCase().indexOf(this.filtersConfig.queryString.toLowerCase()) !== -1) ||
          (!!report.templateName && report.templateName?.toLowerCase().indexOf(this.filtersConfig.queryString.toLowerCase()) !== -1)))
    }) || [];
  }

  private initPieChartData() {

    this.chartSegments = [];
    this.reportStatusCount = {
      "NOT_CREATED": 0,
      "STAND_BY": 0,
      "STUCK": 0,
      "IN_PROGRESS": 0,
      "DONE": 0
    }

    this.reportsCopy.forEach(r => {
      this.reportStatusCount[r.statusGroup] += 1;
    })

    this.chartSegments.push({value: this.reportStatusCount["DONE"], color: '#96D696', name: 'DONE'});
    this.chartSegments.push({value: this.reportStatusCount["STAND_BY"], color: '#BDD5F5', name: 'STAND_BY'});
    this.chartSegments.push({value: this.reportStatusCount["STUCK"], color: '#FF9C9D', name: 'STUCK'});
    this.chartSegments.push({value: this.reportStatusCount["NOT_CREATED"], color: '#D9D9D9', name: 'NOT_CREATED'});
    this.chartSegments.push({value: this.reportStatusCount["IN_PROGRESS"], color: '#CCB6E2', name: 'IN_PROGRESS'});

  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningReportsView', {
    bindings: {},
    template: require('./planning-reports-view.html').default,
    controller: PlanningReportsViewComponent
  });
